import { useState } from 'react';
import { MdOutlineLibraryBooks } from 'react-icons/md';
import Tooltip from '../Tooltip/Tooltip';
import './CampoHashCadastro.css';
export default function CampoHashCadastro({
    value,
    title = "",
    usarCorAzul = true,
    qtdEncript = 0.0
}) {
    const [tooltip, setTooltip] = useState('Copiar');

    const textoCriptografado = (() => {
        if (qtdEncript === 0.0) return value;
        if (!value) return value;

        const tamanho = String(value).length;
        const qtdMascarada = Math.floor(tamanho * qtdEncript);

        const mascarado = "*".repeat(qtdMascarada);
        const visivel = String(value).slice(qtdMascarada);

        return mascarado + visivel;
    })();

    const copiar = async (e) => {
        e.stopPropagation();

        try {
            await navigator.clipboard.writeText(value);
            setTooltip('Copiado!');
            setTimeout(() => setTooltip('Copiar'), 1500);
        } catch (err) {
            console.error('Erro ao copiar', err);
        }
    };

    return (
        <div className="hash-cadastro-wrapper">
            {title && (
                <span className="hash-cadastro-title">
                    {title}
                </span>
            )}

            <div
                className={`hash-cadastro ${usarCorAzul ? 'hash-cadastro-azul' : 'hash-cadastro-preto'}`}
                onClick={copiar}
            >
                <Tooltip text={tooltip}>
                    <div className="hash-cadastro-content">
                        <span className="hash-cadastro-text">
                            {textoCriptografado}
                        </span>
                        <MdOutlineLibraryBooks className="hash-cadastro-copy" />
                    </div>
                </Tooltip>
            </div>
        </div>
    );
}
